import { render, staticRenderFns } from "./MandateChangeData.vue?vue&type=template&id=040b3995&"
import script from "./MandateChangeData.vue?vue&type=script&lang=js&"
export * from "./MandateChangeData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports